import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import { fmtDate } from "@/lib/fers";

export function footerAndSave(doc, file, note = "General guide, not an official OPM document; confirm deadlines with your agency HR") {
  const pages = doc.getNumberOfPages();
  for (let i = 1; i <= pages; i++) {
    doc.setPage(i);
    doc.setFontSize(8).setTextColor(120).text(`PillarWealth.io  |  ${note}  |  Page ${i} of ${pages}`, 40, doc.internal.pageSize.getHeight() - 20);
  }
  const a = document.createElement("a");
  a.href = URL.createObjectURL(doc.output("blob"));
  a.download = `${file}-${new Date().toISOString().slice(0, 10)}.pdf`;
  a.click();
  setTimeout(() => URL.revokeObjectURL(a.href), 1000);
  return doc;
}

function header(doc, title, { name, profile, retireDay }) {
  doc.setFont("helvetica", "bold").setFontSize(18).setTextColor(15, 23, 42).text(title, 40, 50);
  doc.setFont("helvetica", "normal").setFontSize(10).setTextColor(70);
  doc.text(`${name || "Employee"}  |  ${profile.retirement_system}  |  Retirement day ${fmtDate(retireDay)}  |  Generated ${fmtDate(new Date())}`, 40, 68);
}

function questionsTable(doc, questions, startY, answers = {}) {
  autoTable(doc, {
    startY,
    head: [["#", "Topic", "Question", "Answer / notes"]],
    body: questions.map((q, i) => [i + 1, q.topic, q.question, answers[q.id] || ""]),
    styles: { fontSize: 9, cellPadding: 6, valign: "top", lineColor: [226, 232, 240], lineWidth: 0.5 },
    headStyles: { fillColor: [15, 23, 42], textColor: 255 },
    columnStyles: { 0: { cellWidth: 22 }, 1: { cellWidth: 78, textColor: [8, 145, 178] }, 2: { cellWidth: 250 }, 3: { minCellHeight: 46 } },
    margin: { left: 40, right: 40 },
  });
}

export function exportHrPdf(questions, meta) {
  const doc = new jsPDF({ unit: "pt", format: "letter" });
  header(doc, "Questions for HR", meta);
  questionsTable(doc, questions, 84, meta.answers);
  return footerAndSave(doc, "hr-questions");
}

export function exportChecklistPdf(steps, done, { name, profile, retireDay, questions = [], answers = {} }) {
  const doc = new jsPDF({ unit: "pt", format: "letter" });
  const W = doc.internal.pageSize.getWidth();
  header(doc, "Retirement Checklist", { name, profile, retireDay });
  const count = steps.filter((s) => done[s.id]).length;
  doc.setTextColor(20).text(`Progress: ${count} of ${steps.length} steps done  |  ${steps.filter((s) => s.unlocked).length} unlocked`, 40, 84);
  autoTable(doc, {
    startY: 98,
    head: [["#", "Step", "Form", "Unlocks", "Status", "Notes / HR initials"]],
    body: steps.map((s, i) => [i + 1, `${s.title}\n${s.detail}`, s.form || "-", `${fmtDate(s.unlock)}\n${s.months ? `${s.months} mo before` : "Retirement day"}`, done[s.id] ? "Done" : s.unlocked ? "Open" : "Upcoming", ""]),
    styles: { fontSize: 8, cellPadding: 5, valign: "top", lineColor: [226, 232, 240], lineWidth: 0.5 },
    headStyles: { fillColor: [15, 23, 42], textColor: 255 },
    columnStyles: { 0: { cellWidth: 20 }, 1: { cellWidth: 210 }, 2: { cellWidth: 70 }, 3: { cellWidth: 72 }, 4: { cellWidth: 52, fontStyle: "bold" }, 5: { cellWidth: W - 80 - 424, minCellHeight: 34 } },
    didParseCell: (d) => {
      if (d.section !== "body" || d.column.index !== 4) return;
      d.cell.styles.textColor = d.cell.raw === "Done" ? [5, 150, 105] : d.cell.raw === "Open" ? [180, 83, 9] : [100, 116, 139];
    },
    margin: { left: 40, right: 40 },
  });
  if (questions.length) {
    doc.addPage();
    header(doc, "Questions for HR", { name, profile, retireDay });
    questionsTable(doc, questions, 84, answers);
  }
  return footerAndSave(doc, "retirement-checklist");
}
